import { render, staticRenderFns } from "./singleSubjectAvg_tea_month_new2.vue?vue&type=template&id=b5fe6cc6&scoped=true&"
import script from "./singleSubjectAvg_tea_month_new2.vue?vue&type=script&lang=js&"
export * from "./singleSubjectAvg_tea_month_new2.vue?vue&type=script&lang=js&"
import style0 from "./singleSubjectAvg_tea_month_new2.vue?vue&type=style&index=0&id=b5fe6cc6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5fe6cc6",
  null
  
)

export default component.exports